import React from "react";

const IconExplicit = () => {
  return (
    <svg
  height="100%"
  viewBox="0 0 512 512"
  width="100%"
  xmlns="http://www.w3.org/2000/svg"
  style={{
    fillRule: "nonzero",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }}
>
  <defs />
  <g id="Full" data-layer-name="Full">
    <path
      d="M49.28 91.6486C49.28 68.2491 68.2491 49.28 91.6486 49.28L420.351 49.28C443.751 49.28 462.72 68.2491 462.72 91.6486L462.72 420.351C462.72 443.751 443.751 462.72 420.351 462.72L91.6486 462.72C68.2491 462.72 49.28 443.751 49.28 420.351L49.28 91.6486Z"
      fill="#ffffff"
      fillOpacity={0.5}
      fillRule="nonzero"
      opacity={1}
      stroke="none"
    />
    <g opacity={1} data-layer-name="Group 1">
      <g opacity={1} data-layer-name="Group 1">
        <path
          d="M215.817 336.366L215.817 277.187L334.539 277.187L334.539 231.16L215.817 231.16L215.817 175.634L350.247 175.634L350.247 128.146L157.004 128.146L157.004 383.854L354.996 383.854L354.996 336.366L215.817 336.366Z"
          fill="#ffffff"
          fillRule="nonzero"
          opacity={1}
          stroke="none"
        />
      </g>
    </g>
  </g>
</svg>
    
  );
}

export default IconExplicit;